import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { clearJobChatUnread, markJobChatRead } from "../actions/jobChats.actions";
import { jobChatsQueryKeys } from "../jobChats.queryKeys";

export const useJobChatRead = (jobEventUid, companyId = undefined) => {
  const token = sessionStorage.getItem("token");
  const queryClient = useQueryClient();
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const readMutation = useMutation({
    mutationFn: () => markJobChatRead(token, jobEventUid, effectiveCompanyId),
    onMutate: () => {
      if (!effectiveCompanyId) return;
      queryClient.setQueryData(jobChatsQueryKeys.active(effectiveCompanyId), (old) => clearJobChatUnread(old, jobEventUid));
      queryClient.setQueryData(jobChatsQueryKeys.history(effectiveCompanyId), (old) => clearJobChatUnread(old, jobEventUid));
    },
  });

  return { markRead: readMutation.mutate };
};
